<script>
  import { fade } from "svelte/transition";
  import Load from "../components/Load.svelte";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Placeholder from "../components/placeholder/Placeholder.svelte";
  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  //log

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  let items = [];
  let itemsDisplay = false;
  let loading = "block";

  function fetchSRV() {
    axios
      .get(settings.url + "/sipade/hotspot-gateway", {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        items = response.data;
        itemsDisplay = true;
        loading = "hidden";
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: "Tidak terhubung dengan baik, silahkan muat ulang halaman",
            color: "orange",
          },
        ];
        //location.reload();
      })
      .then(function () {
        // always executed
      });
  }

  fetchSRV();
</script>

<svelte:head>
  <title>Hotspot Ke Dekatan</title>
</svelte:head>

{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar backbtn="true" message={navigation["message"]} title="Hotspot" />
<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  <div class="flex flex-wrap items-center max-w-6xl mx-auto my-5 lg:my-0">
    <div class="w-full px-3 py-5 overflow-hidden">
      <h2 class="w-full py-2 my-2 text-2xl text-center">
        Monitor <b>Hotspot</b>
      </h2>
      <div
        class="{loading} max-w-6xl flex items-center flex-wrap mx-auto my-5 lg:my-0"
      >
        <h2 class="w-full py-2 my-2 text-lg text-center">
          Sedang mencari target server...
        </h2>
        <div class="w-full px-2 py-2 mx-auto lg:w-1/3 lg:px-2">
          <div
            class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer group hover:text-green-700"
          >
            <Placeholder type="5" css="" />
          </div>
        </div>

        <div class="w-full px-2 py-2 mx-auto lg:w-1/3 lg:px-2">
          <div
            class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer group hover:text-green-700"
          >
            <Placeholder type="5" css="" />
          </div>
        </div>

        <div class="w-full px-2 py-2 mx-auto lg:w-1/3 lg:px-2">
          <div
            class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer group hover:text-green-700"
          >
            <Placeholder type="5" css="" />
          </div>
        </div>

        <div class="w-full px-2 py-2 mx-auto lg:w-1/3 lg:px-2">
          <div
            class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer group hover:text-green-700"
          >
            <Placeholder type="5" css="" />
          </div>
        </div>
      </div>

      {#if itemsDisplay}
        <p class="text-lg text-center">
          Silakan pilih kanal hotspot dibawah ini
        </p>
        <div class="flex flex-wrap items-center max-w-6xl mx-auto my-5 lg:my-0">
          {#each items as p}
            <div class="w-full px-2 py-2 mx-auto lg:w-1/2 lg:px-2">
              <a
                class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer group hover:text-green-700"
                href="./hotspot/{p.id}"
              >
                <div class="flex items-center justify-between">
                  <span class="text-xl font-bold text-gray-800">{p.name}</span>
                  <span
                    class="px-3 py-0 text-xs text-green-800 bg-green-200 rounded-full"
                  >
                    Online
                  </span>
                </div>
                <div>
                  <h1 class="mt-2 text-lg group-hover:text-green-700">
                    {p.descriptions}
                  </h1>
                </div>
                <div />
              </a>
            </div>
          {:else}
            <div class="w-full px-2 py-2 mx-auto lg:w-1/2 lg:px-2">
              <div
                class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer"
              >
                <div class="flex items-center justify-between">
                  <span class="text-xl font-bold text-gray-800">Oops...!</span>
                  <span
                    class="px-3 py-0 text-xs text-red-800 bg-red-200 rounded-full"
                    >Error</span
                  >
                </div>
                <div>
                  <h1 class="mt-2 text-lg">
                    Tidak menemukan server, cobalah muat ulang halaman ini
                  </h1>
                </div>
                <div class="text-right border-t">
                  <button
                    on:click|preventDefault={() => location.reload()}
                    type="button"
                    class="w-full px-5 py-2 my-2 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                    >Muat Ulang</button
                  >
                </div>
              </div>
            </div>
          {/each}
        </div>
      {:else}
        <Load />
      {/if}
    </div>
  </div>
</main>
